module.exports = __webpack_public_path__ + "img/INTERIOR-CIAZ-5.d7aadb83.jpg";